export const ERROR_MESSAGE = 'Service is temporary unavailable. Please try later.';
export const NO_RESULTS_MESSAGE = 'No results found';
export const UNCLEAR_QUERY_MESSAGE = 'The search query is less than the minimum allowed, continue typing...';
export const MAX_RESULTS = 25;
